module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAAqUlEQVQ4T+3SPQrCQBAF4PdcwcZ7CF5BdtVjSLyGrRexlKy9vT/sNcTSOp2Igk+CKBYbYhJLp52dj9nHUN6eABo0KGrlLhA6DQz8CPFuDSCDcKu3jQzzQXk7A9mrhdyVPZHUbUGM34h0BnktQNsAuh+9QxwhEk6CjyFaDiyMCeWIMGUS0iji7RDg/gtEc7S4iX5H6gNclCPVEi7I5I/kF7sDOKoWxeu1jg8X1FHu5HciBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/goodsImg.png
// module id = MTY9
// module chunks = 2